import get from 'lodash.get';

export default class FormController {
  constructor() {
    this.formStatus = { fields: {} };

    this.onFocus = this.onFocus.bind(this);
    this.checkErrors = this.getFormErrors.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.saveAttempted = this.saveAttempted.bind(this);
    this.getErrorMetaData = this.getErrorMetaData.bind(this);
  }

  getErrorMetaData(settings) {
    let editSinceSaveAttempted = true;

    if (settings.saveAttempted) {
      this.saveAttempted();
      editSinceSaveAttempted = false;
    }

    return {
      clean: false,
      hasSaveBeenAttempted: this.formStatus.hasSaveBeenAttempted,
      editSinceSaveAttempted
    };
  }

  getFormErrors(validation, settings = {}) {
    let errors = {
      meta: this.getErrorMetaData(settings)
    };

    if (!validation.error) {
      errors.meta.clean = true;
      return errors;
    }

    validation.error.details.forEach(error => {
      let name = error.path.join('.');

      errors[name] = {
        message: error.message,
        showError: false
      };

      let isFocused = name === this.formStatus.focused;
      let isTouched = get(this.formStatus, ['fields', name, 'touched']);

      if (this.formStatus.hasSaveBeenAttempted) {
        errors[name].showError = true;
        return;
      }

      if (isFocused && isTouched) {
        errors[name].showError = true;
        return;
      }

      if (isFocused && !isTouched) {
        errors[name].message = false;
      }

      if (!isFocused && !isTouched) {
        errors[name].message = false;
        return;
      }

      if (!isFocused && isTouched) {
        errors[name].showError = true;
        return;
      }
    });

    return errors;
  }

  saveAttempted() {
    this.formStatus.hasSaveBeenAttempted = true;
  }

  onFocus(event) {
    let name = event.target.name;

    if (!this.formStatus.fields[name]) {
      this.formStatus.fields[name] = {};
    }

    this.formStatus.currentInUse = name;
    this.formStatus.focused = name;
  }

  onBlur(event) {
    let name = event.target.name;

    if (this.formStatus.currentInUse) {
      this.formStatus.fields[this.formStatus.currentInUse].touched = true;
    }
    this.formStatus.currentInUse = null;

    if (!this.formStatus.fields[name]) {
      this.formStatus.fields[name] = {};
    }

    this.formStatus.focused = null;
  }

  showFormSaveError(validationErrors) {
    return (
      get(validationErrors, 'meta.hasSaveBeenAttempted') &&
      !get(validationErrors, 'meta.editSinceSaveAttempted') &&
      !get(validationErrors, 'meta.clean')
    );
  }

  shouldShowError(validationErrors, paths) {
    paths = Array.isArray(paths) ? paths : [paths];
    return !!paths
      .map(path => get(validationErrors, [path, 'showError'], false))
      .filter(e => e)[0];
  }

  getErrorMessage(validationErrors, paths) {
    paths = Array.isArray(paths) ? paths : [paths];
    return paths
      .map(path => get(validationErrors, [path, 'message'], ''))
      .filter(e => e !== '')[0];
  }
}
